import { ToggleElement } from "appworks/graphics/elements/toggle-element";
import { AbstractControl } from "appworks/ui/controls/abstract-control";

export class TGRToggleDisabledControl extends AbstractControl {

    constructor(toggle: ToggleElement) {
        super();
        toggle.setVisible(false);
    }
}
